// Graph Builderのレジストリ初期化

import { graphRegistry } from './GraphRegistry';
import { histogramRenderer } from './renderers/HistogramRenderer';
import { scatterPlotRenderer } from './renderers/ScatterPlotRenderer';
import { barChartRenderer } from './renderers/BarChartRenderer';
import { pairPlotRenderer } from './renderers/PairPlotRenderer';
import { rugPlotRenderer } from './renderers/RugPlotRenderer';
import { customGraphRenderer } from './renderers/customGraphRenderer';
import { HistogramConfigComponent } from './config/HistogramConfig';
import { ScatterPlotConfigComponent } from './config/ScatterPlotConfig';
import { BarChartConfigComponent } from './config/BarChartConfig';
import { PairPlotConfigComponent } from './config/PairPlotConfig';
import { RugPlotConfigComponent } from './config/RugPlotConfig';
import { CustomGraphConfigComponent } from './config/CustomGraphConfig';
import { TimeSeriesRenderer } from '../../tabs/GraphBuilderTab/graphs/TimeSeriesRenderer';
import { TimeSeriesConfig } from '../../tabs/GraphBuilderTab/graphs/TimeSeriesConfig';

// 初期化済みフラグ
// 開発時のホットリロードやReact Strict Modeによってモジュールが再評価されるため、
// 複数回の初期化を防ぐためのフラグです。
let initialized = false;

// グラフタイプを登録します
export function initializeGraphRegistry() {
  // 既に初期化済みの場合はスキップします
  if (initialized) {
    return;
  }
  initialized = true;

  // ヒストグラム
  graphRegistry.register('histogram', {
    name: 'Histogram',
    renderer: histogramRenderer,
    configComponent: HistogramConfigComponent,
    description: 'Display the distribution of a single numeric variable using bars. Useful for understanding the frequency and shape of data distribution, identifying outliers, and comparing distributions across groups.'
  });

  // 散布図
  graphRegistry.register('scatter', {
    name: 'Scatter Plot',
    renderer: scatterPlotRenderer,
    configComponent: ScatterPlotConfigComponent,
    description: 'Visualize the relationship between two numeric variables with points. Reveals correlations, patterns, clusters, and outliers. Supports interactive selection, density visualization, and grouping by categorical variables.'
  });

  // 時系列プロット
  const timeSeriesRenderer = new TimeSeriesRenderer();
  graphRegistry.register('timeseries', {
    name: 'Time Series Plot',
    renderer: timeSeriesRenderer,
    configComponent: TimeSeriesConfig,
    description: 'Plot data values over time to identify trends, seasonality, and patterns. Supports multiple time series with different line styles, and allows comparison across time periods.'
  });

  // 棒グラフ
  graphRegistry.register('bar', {
    name: 'Bar Chart',
    renderer: barChartRenderer,
    configComponent: BarChartConfigComponent,
    description: 'Compare values across categories using vertical or horizontal bars. Ideal for categorical data comparison, showing rankings, and displaying aggregated statistics like counts, sums, or averages.'
  });

  // ペアプロット
  graphRegistry.register('pairplot', {
    name: 'Pair Plot',
    renderer: pairPlotRenderer,
    configComponent: PairPlotConfigComponent,
    description: 'Create a matrix of scatter plots showing pairwise relationships between multiple numeric variables. Diagonal shows distributions. Useful for exploring correlations and multivariate patterns in your data.'
  });

  // Rug Plot
  graphRegistry.register('rugplot', {
    name: 'Rug Plot',
    renderer: rugPlotRenderer,
    configComponent: RugPlotConfigComponent,
    description: 'Visualize the temporal distribution of datetime events. Shows individual events as vertical ticks along a timeline with an optional intensity curve using moving average estimation.'
  });

  // Custom Graph (Grammar of Graphics)
  graphRegistry.register('custom', {
    name: 'Custom Graph (Preview)',
    renderer: customGraphRenderer,
    configComponent: CustomGraphConfigComponent,
    description: 'Create flexible visualizations based on Grammar of Graphics principles. Build layered plots by combining geometric elements, statistical transformations, and aesthetic mappings. Currently supports basic scatter plots.'
  });

  // TODO: 将来的に以下のグラフタイプを追加
  // - Box Plot
  // - Heatmap
  // - Correlation Matrix
}

// 再エクスポート
export { graphRegistry } from './GraphRegistry';
export { GraphBuilderTabContent } from './GraphBuilderTabContent';